<template>
  <div v-if="isRepeatPop" class="popFixed">
    <div class="masking" @click="repeatPop" />
    <div class="tcCon">
      <div class="item">
        <span>温馨提示</span>
        <p>您已有申请正在审批！</p>
      </div>
      <div class="btnCon only">
        <span @click="repeatPop">我知道了</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RepeatPop',
  data() {
    return {
      isRepeatPop: true
    }
  },
  methods: {
    repeatPop() {
      this.isRepeatPop = !this.isRepeatPop
    }
  }
}
</script>
